import {call, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import InterestsActions from '../Redux/InterestsRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

const FileDownload = require('js-file-download')

export function* getInterests(api, authApi, {id, page, page_size, sort_field, sort_order, filter}) {
  try {
    const response = yield call(api.getInterests, id, page, page_size, sort_field, sort_order, filter)
    if (response && response.ok) {
      yield put(InterestsActions.interestsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(InterestsActions.interestsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getInterests(api, authApi, {id, page, page_size, sort_field, sort_order, filter})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(InterestsActions.interestsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getInterestFile(api, authApi, {id, page, page_size, sort_field, sort_order, filter}) {
  try {
    const response = yield call(api.getInterestFile, id, page, page_size, sort_field, sort_order, filter)
    if (response && response.ok) {
      FileDownload(response.data, `report.csv`)
      yield put(InterestsActions.interestFileSuccess())
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(InterestsActions.interestsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getInterestFile(api, authApi, {id, page, page_size, sort_field, sort_order, filter})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(InterestsActions.interestsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getInterestExample(api, authApi, {language}) {
  try {
    const response = yield call(api.getInterestExample, language)
    if (response && response.ok) {
      yield put(InterestsActions.interestExampleSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(InterestsActions.interestsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getInterestExample(api, authApi, {language})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(InterestsActions.interestsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
